import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react";
import _without from "lodash/without";
import { getAgentFilter } from "../Store/Actions/TicketAction";
import "./CallHistory.css";

import {
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  InputAdornment,
  ListItemIcon,
  Menu,
  useTheme,
  MenuItem,
  TextField,
  Box,
  Chip,
  FormControl,
  Select,
  OutlinedInput,
  InputLabel,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import DateType1 from "../Images/DateType1.svg";
import DateType2 from "../Images/DateType2.svg";
import DateType3 from "../Images/DateType3.svg";
import DateType4 from "../Images/DateType4.svg";

const CallLogFilter = ({
  agentId,
  level,
  isOpen,
  keyword,
  setFilterList,
  setIsModalShown,
  setKeyword,
  setSelected,
}) => {
  const [type, setType] = useState("");
  const [typeStatusLog, setTypeStatusLog] = useState([]);
  const [container, setContainer] = useState([]);
  const [typeAgentLog, setTypeAgentLog] = useState([]);
  const [listAgentLog, setListAgent] = useState([]);

  const initialParams = {
    // Range initialized as 1 day before current date
    datestart: moment().subtract(1, "day"),

    dateend: moment(),
  };

  const [searchParams, setSearchParams] = useState(initialParams);
  const statusLog = ["Outbound", "Inbound", "Connected"];
  //dummy
  // const agentLog = [
  //   "Tele Two",
  //   "Tele One",
  //   "Tele Tele",
  //   "QA 1",
  //   "QA 2",
  //   "Justin Case",
  // ];

  useEffect(() => {
    // Get agent data for search select options
    getAgentFilter(agentId)
      .then((response) => {
        if (response.status) {
          setListAgent(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  const handleClose = () => {
    setIsModalShown(false);
  };

  const handleSubmit = () => {
    setFilterList([type, typeStatusLog, typeAgentLog, searchParams]);
    setIsModalShown(false);
    setSelected(null);
  };

  const handleClear = () => {
    setType("");
    setTypeStatusLog([]);
    setTypeAgentLog([]);
    setSearchParams("");
    setFilterList(["", [], [], ""]);
    setSelected(null);
    setKeyword("");
  };

  const handleChangeStatus = (event) => {
    const {
      target: { value },
    } = event;
    setTypeStatusLog(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeAgent = (event) => {
    const {
      target: { value },
    } = event;
    setTypeAgentLog(typeof value === "string" ? value.split(",") : value);
  };

  const handleDeleteStatus = (e, value) => {
    e.preventDefault();
    setTypeStatusLog((current) => _without(current, value));
  };

  const handleDeleteAgent = (e, value) => {
    e.preventDefault();
    setTypeAgentLog((current) => _without(current, value));
  };

  const newListRaw = Array.isArray(listAgentLog)
    ? listAgentLog.map(({ AgentID, AgentName }) => [AgentID, AgentName])
    : Object.entries(listAgentLog);

  const newList = Object.fromEntries(newListRaw);

  //dummy
  // const newList = {
  //   90: "Oliver Hansen",
  //   2: "Van Henry",
  //   3: "April Tucker",
  //   4: "Ralph Hubbard",
  //   100: "Omar Alexander",
  //   6: "Carlos Abbott",
  //   7: "Miriam Wagner",
  //   8: "Bradley Wilkerson",
  //   9: "Virginia Andrews",
  //   10: "Kelly Snyder",
  // };

  // console.log("whatdaafack", newList);

  return (
    <Dialog
      open={isOpen}
      className="dialog add-edit-contact"
      fullWidth
      maxWidth="md"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <form method="post">
          <div className="dialog-content">
            <div className="header-container">
              <h2 className="title">Advanced Search</h2>

              <IconButton className="close-button" onClick={handleClose}>
                <CloseOutlined sx={{ fontSize: 28 }} />
              </IconButton>
            </div>
            <div className="form-container">
              <section className="form-inputs">
                <div className="item type">
                  <TextField
                    fullWidth
                    label="By Date"
                    name="type"
                    placeholder="By Date"
                    required
                    select
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <MenuItem value="day">
                      <ListItemIcon>
                        <img src={DateType1} />
                      </ListItemIcon>
                      Today
                    </MenuItem>

                    <MenuItem value="week">
                      <ListItemIcon>
                        <img src={DateType2} />
                      </ListItemIcon>
                      By Week
                    </MenuItem>

                    <MenuItem value="month">
                      <ListItemIcon>
                        <img src={DateType3} />
                      </ListItemIcon>
                      By Month
                    </MenuItem>

                    <MenuItem value="manual">
                      <ListItemIcon>
                        <img src={DateType4} />
                      </ListItemIcon>
                      Manual Selection
                    </MenuItem>
                  </TextField>
                </div>
                {type === "manual" ? (
                  <div className="item type">
                    <div className="date-range">
                      <DatePicker
                        disableFuture
                        label="Start Date"
                        maxDate={searchParams.dateend}
                        value={searchParams.datestart}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(newValue) =>
                          setSearchParams({
                            ...searchParams,
                            datestart: newValue,
                          })
                        }
                      />

                      <Icon
                        color="#7E7E7E"
                        height="26"
                        icon="mdi:arrow-expand"
                        width="26"
                      />

                      <DatePicker
                        disableFuture
                        label="End Date"
                        minDate={searchParams.datestart}
                        value={searchParams.dateend}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(newValue) =>
                          setSearchParams({
                            ...searchParams,
                            dateend: newValue,
                          })
                        }
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="item type">
                  <FormControl fullWidth>
                    <InputLabel>By Status</InputLabel>
                    <Select
                      multiple
                      value={typeStatusLog}
                      onChange={handleChangeStatus}
                      input={
                        <OutlinedInput
                          id="select-multiple-chip"
                          label="By Status"
                        />
                      }
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            Height: 22,
                            alignContent: "center",
                          }}
                        >
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              clickable
                              sx={{ height: 26 }}
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) =>
                                    event.stopPropagation()
                                  }
                                />
                              }
                              onDelete={(e) => handleDeleteStatus(e, value)}
                            />
                          ))}
                        </Box>
                      )}
                    >
                      {statusLog.map((statusLog) => (
                        <MenuItem key={statusLog} value={statusLog}>
                          {statusLog}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                {level > 0 ? (
                  <div className="item type">
                    <FormControl fullWidth>
                      <InputLabel>By Agent</InputLabel>
                      <Select
                        multiple
                        value={typeAgentLog}
                        onChange={handleChangeAgent}
                        input={
                          <OutlinedInput
                            id="select-multiple-chip"
                            label="By Agent"
                          />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              Height: 22,
                              alignContent: "center",
                            }}
                          >
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                label={newList[value]}
                                sx={{ height: 26 }}
                                clickable
                                deleteIcon={
                                  <CancelIcon
                                    onMouseDown={(event) =>
                                      event.stopPropagation()
                                    }
                                  />
                                }
                                onDelete={(e) => handleDeleteAgent(e, value)}
                              />
                            ))}
                          </Box>
                        )}
                      >
                        {Object.keys(newList).map((id) => (
                          <MenuItem key={id} value={id}>
                            {newList[id]}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                ) : (
                  ""
                )}

                <div className="item type">
                  <TextField
                    fullWidth
                    label="By Keyword"
                    name="keyword"
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                  />
                </div>
              </section>
            </div>
            <section className="buttons">
              <button className="cancel" type="button" onClick={handleClear}>
                Clear
              </button>
              {type ? (
                <button
                  className="confirm"
                  type="button"
                  onClick={handleSubmit}
                >
                  Confirm
                </button>
              ) : (
                <button
                  className="confirm"
                  type="button"
                  disabled="disabled"
                  onClick={handleSubmit}
                >
                  Confirm
                </button>
              )}
            </section>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default CallLogFilter;
